'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z' }),
        React.createElement('path', { d: 'M448 704h128v128h-128v-128z' }),
        React.createElement('path', { d: 'M640 704h128v128h-128v-128z' }),
        React.createElement('path', { d: 'M640 512h128v128h-128v-128z' }),
        React.createElement('path', { d: 'M448 512h128v128h-128v-128z' }),
        React.createElement('path', { d: 'M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM832 896h-640v-448h640v448z' }),
        React.createElement('path', { d: 'M256 512h128v128h-128v-128z' }),
        React.createElement('path', { d: 'M256 704h128v128h-128v-128z' })
    ));
};